module.exports = __webpack_public_path__ + "static/media/raise-hand-line.0f04f2bf.svg";